<template>
  <div
    :class="['form-input', '--is-' + type, fakeDisabled ? '--is-fakeDisabled' : '']"
    :style="display === 'block' ? 'display: block;' : 'display: inline-block;'"
  >
    <!-- input type text, search -->
    <div
      v-if="type === 'text' || type === 'number' || type === 'search' || type === 'date'"
      class="form-input__text"
    >
      <input
        v-if="type == 'number'"
        :id="id || this.uniqueId()"
        :name="name"
        :type="type"
        :min="min"
        :max="max"
        :placeholder="placeholder"
        :class="['form-input__control', '--is-' + size]"
        :required="required"
        :value="value"
        inputmode="numeric"
        pattern="[0-9]*"
        v-on:input="updateValue($event)"
      >

      <input
        v-else-if="type == 'date'"
        :id="id || this.uniqueId()"
        :name="name"
        :type="type"
        :min="min"
        :max="max"
        :class="['form-input__control', '--is-' + size]"
        :required="required"
        :value="value"
        v-on:input="updateValue($event)"
      >

      <input
        v-else
        :id="id || this.uniqueId()"
        :name="name"
        :type="type"
        :min="min"
        :max="max"
        :placeholder="placeholder"
        :class="['form-input__control', '--is-' + size]"
        :required="required"
        :value="(value === 'true' ? true : false)"
        v-on:input="updateValue($event)"
      >

      <i v-if="icon" :class="'icon icon-' + icon + ' form-input__icon'"></i>
    </div>
    <!-- /input type text, search -->

    <!-- textarea -->
    <div
      v-if="type === 'textarea'"
      class="form-input__textarea"
    >
      <textarea
        :id="id || this.uniqueId()"
        :name="name"
        :maxlength="maxlength"
        :rows="rows"
        :placeholder="placeholder"
        :class="['form-input__control', '--is-' + size]"
        :required="required"
        v-on:input="updateValue($event)"
        v-model="message"
      ></textarea>
    </div>
    <!-- /textarea -->

    <!-- textarea embeded *HACK because normal textarea is not working properly *-->
    <div
      v-if="type === 'textarea-embeded'"
      class="form-input__textarea"
    >
      <slot></slot>
    </div>
    <!-- /textarea -->

    <!-- input type checkbox, radio -->
    <div
      v-else-if="type === 'checkbox' || type === 'radio'"
      class="form-input__check"
    >
      <input
        :id="id || this.uniqueId()"
        :name="name"
        :type="type"
        :class="['form-input__control', '--is-' + size]"
        :required="required"
        :value="value"
        :checked="checked"
        @change="updateValue($event)"
      >

      <!-- <div
        v-if="$slots.before"
        class="form-input__check-extra --is-before"
      >
        <slot name="before"/>
      </div> -->

      <label
        v-if="$slots.default"
        :for="id || this.uniqueId()"
      >
        <slot></slot>
      </label>

      <div
        v-if="$slots.after"
        class="form-input__check-extra --is-after"
      >
        <slot name="after"/>
      </div>
    </div>
    <!-- /input type checkbox, radio -->
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    display: {
      type: String,
      default: 'block'
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number
    },
    rows: {
      type: Number,
      default: 5
    },
    placeholder: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    icon: {
      type: String
    },
    checked: {
      type: Boolean,
      default: false
    },
    value: {},
    filterTextarea: {
      type: Boolean,
      default: false
    },
    fakeDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      textareaValue: ''
    };
  },
  mounted() {
    if (this.type === 'textarea') {
      this.textareaValue = this.value;
    }
  },
  methods: {
    uniqueId () {
      return 'fid_' + this._uid;
    },

    updateValue (event) {
      if (this.type === 'text' || this.type === 'textarea' || this.type === 'number' || this.type === 'search' || this.type === 'date') {
        this.$emit('input', event.target.value);
      } else if (this.type === 'checkbox') {
        this.$emit('input', event.target.checked);
      } else if (this.type === 'radio') {
        this.$emit('change', event.target.value);
      }
    }
  },
  computed: {
    message: {
      get() {
        return this.textareaValue;
      },
      set(value) {
        this.textareaValue = value;
      }
    }
  },
  watch: {
    message(newVal) {
      if (this.filterTextarea) {
        this.$set(this, 'message', newVal.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, ''));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/**
 * FormInput
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Form input field
 * @since 2021-03-31
**/

$component: 'form-input';

.#{$component} {
  width: auto;
  margin: 0;

  // Input text, number, search
  &.--is-text,
  &.--is-number,
  &.--is-search {
  }

  &__text {
  }

  // Date
  &.--is-date {
    .#{$component}__control {
      position: relative;

      &::-webkit-calendar-picker-indicator {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        width: auto;
        height: auto;
        margin: 0;
        background: transparent;
        color: transparent;
        cursor: pointer;
      }

      &::-webkit-inner-spin-button {
        z-index: 1;
      }

      &::-webkit-clear-button {
        z-index: 1;
      }
    }
  }

  // Textarea
  &.--is-textarea {
    display: block;
  }

  &__textarea {
    textarea {
      display: block;
    }
  }

  // Checkbox and radio
  &.--is-checkbox,
  &.--is-radio {
    position: relative;

    // Common styles for both checkbox and radio
    .#{$component}__control[type='checkbox'],
    .#{$component}__control[type='radio'] {
      position: absolute;
      width: 0;
      height: 0;
      visibility: hidden;

      & + label {
        position: relative;
        padding-left: 27px;
        cursor: pointer;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: 2px;
          left: 0;
          width: 20px;
          height: 20px;
          border: 1px solid $sky-dark;
          @include linear-gradient(to bottom, $white, $sky-lighter);
          box-shadow: 0 1px 0 0 rgba($ink, 0.08);
          cursor: pointer;
          transition: all 0.05s ease-in-out;
        }

        &:after {
          content: '';
          position: absolute;
          cursor: pointer;
          opacity: 0;
        }

        &:hover:before {
          border: 2px solid $primary;
        }
      }
      &:checked + label {
        &:before {
          border: 2px solid $primary;
        }

        &:after {
          opacity: 1;
        }
      }
    }

    // Specific styles for checbox
    .#{$component}__control[type='checkbox'] {
      & + label {
        &:before {
          border-radius: $border-radius;
        }

        &:after {
          font-family: 'icomoon' !important;
          content: '\e913';
          color: $primary;
          font-size: 20px;
          line-height: 1;
          font-weight: bold;
          top: 2px;
          left: 0;
          width: 16px;
          height: 16px;
        }
      }
    }

    // Specific styles for radio
    .#{$component}__control[type='radio'] {
      & + label {
        &:before {
          border-radius: $rounded-pill;
        }
        &:after {
          top: 8px;
          left: 6px;
          width: 8px;
          height: 8px;
          border-radius: $rounded-pill;
          background-color: $primary;
        }
      }
    }
  }

  &__check {
    // Used for the description of the options
    > label small {
      display: block;
      color: $ink-lighter;
      @include font-size($font-size-xs);
    }
  }

  &__check-extra {
    padding-left: 27px;
  }

  &__control {
    width: 100%;
    @include padding-top(map-get($spacers, 3) / 3);
    @include padding-right(map-get($spacers, 5) / 3);
    @include padding-bottom(map-get($spacers, 3) / 3);
    @include padding-left(map-get($spacers, 5) / 3);
    border: 1px solid $sky-dark;
    border-radius: $border-radius;
    outline: none;
    box-shadow: inset 0 1px 2px 0 rgba($ink-lighter, 0.20);
    background-color: $white;
    color: $ink;
    @include font-size($font-size-base);
    line-height: $line-height-base;

    &.--is-large {
      @include padding-top(map-get($spacers, 3) / 2);
      @include padding-bottom(map-get($spacers, 3) / 2);
      @include font-size($font-size-lg);

      &.--has-icon {
        @include padding-left((map-get($spacers, 5) / 3) + ($font-size-lg * 1.3));
      }
    }

    &[type='number'] {
      &::-webkit-inner-spin-button,
      ::-webkit-outer-spin-button {
        opacity: 1;
      }
    }
  }

  &__icon {
    position: absolute;
    @include rfs(map-get($spacers, 3) / 2, top);
    @include rfs(map-get($spacers, 5) / 3, left);
    @include font-size($font-size-lg);
    color: $ink-lightest;
  }

  // Disabled state of the component
  &[disabled='disabled'] {
    .#{$component} {
      &__check {
        pointer-events: none;
        opacity: 0.6;

        ::v-deep .badge {
          opacity: 2;
        }
      }
    }
  }

  &.--is-fakeDisabled {
    .#{$component} {
      &__check label {
        pointer-events: none;
        opacity: 0.6;
        cursor: default;
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &.--is-checkbox,
    &.--is-radio {
      .#{$component}__control[type='checkbox'] + label {
        &:before,
        &:after {
          top: 0;
        }
      }

      .#{$component}__control[type='radio'] + label {
        &:before {
          top: 0;
        }

        &:after {
          top: 6px;
        }
      }
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
